var _defs, _g, _g2, _g3, _path, _path2, _rect, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g4, _path33, _path34, _path35, _g5, _path36, _path37, _path38, _path39, _path40, _g6, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g7, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _g8, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _g9, _g10, _g11, _path89, _path90, _rect3, _path91, _path92, _path93, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup29141(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2914",
    "data-name": "Group 2914",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300.162,
    height: 428.162,
    viewBox: "0 0 300.162 428.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17952",
    "data-name": "Rectangle 17952",
    width: 300.162,
    height: 428.162,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17935",
    "data-name": "Rectangle 17935",
    width: 39.657,
    height: 14.272,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17936",
    "data-name": "Rectangle 17936",
    width: 36.882,
    height: 12.809,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17937",
    "data-name": "Rectangle 17937",
    width: 37.229,
    height: 13.323,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17941",
    "data-name": "Rectangle 17941",
    width: 4.957,
    height: 12.205,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17942",
    "data-name": "Rectangle 17942",
    width: 4.954,
    height: 12.205,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17943",
    "data-name": "Rectangle 17943",
    width: 35.375,
    height: 19.573,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17944",
    "data-name": "Rectangle 17944",
    width: 38.411,
    height: 31.209,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17945",
    "data-name": "Rectangle 17945",
    width: 34.648,
    height: 3.676,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17946",
    "data-name": "Rectangle 17946",
    width: 1.08,
    height: 0.388,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17947",
    "data-name": "Rectangle 17947",
    width: 1.004,
    height: 0.349,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17948",
    "data-name": "Rectangle 17948",
    width: 1.014,
    height: 0.363,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2767",
    "data-name": "Group 2767",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2740",
    "data-name": "Group 2740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2739",
    "data-name": "Group 2739",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    transform: "translate(24.205 267.986)",
    opacity: 0.22,
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2731",
    "data-name": "Group 2731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2730",
    "data-name": "Group 2730",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M88.85,541.756a20.638,20.638,0,0,1-1.2,6.878H50.391a19.873,19.873,0,0,1-1.2-6.878,20.454,20.454,0,0,1,1.388-7.393H87.462a20.115,20.115,0,0,1,1.388,7.393",
    transform: "translate(-49.192 -534.364)",
    fill: "#333"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2735",
    "data-name": "Group 2735",
    transform: "translate(25.592 255.161)",
    opacity: 0.22,
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2733",
    "data-name": "Group 2733",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M88.879,521.6H52.013a19.679,19.679,0,0,1,36.882,0Z",
    transform: "translate(-52.013 -508.79)",
    fill: "#333"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2738",
    "data-name": "Group 2738",
    transform: "translate(25.403 282.274)",
    opacity: 0.22,
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2737",
    "data-name": "Group 2737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2736",
    "data-name": "Group 2736",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M51.628,562.854H88.857c-.2.611-.441,1.173-.694,1.752a19.618,19.618,0,0,1-34.832,1.848,21.254,21.254,0,0,1-1.7-3.584Z",
    transform: "translate(-51.628 -562.854)",
    fill: "#333"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M48.922,605.574c4.793,54.628,2.05,83.171-1.971,99.42-.946,3.825-3.58,13.485,1.971,19.56,3.374,3.7,9.824,1.237,33.224,0,3.989-.209,7.238-.338,9.288-.4-5.881.209-7.947-26.454-8.058-29.749q-.615-19.093-1.513-38.074a499.478,499.478,0,0,1,.283-51.141,32.287,32.287,0,0,1-8.783,3.584,34.068,34.068,0,0,1-8.168,1,33.358,33.358,0,0,1-16.273-4.194",
    transform: "translate(-23.109 -301.683)",
    fill: "#0d61d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M204.027,523.068c.915,6.927,1.277,15.091-3.58,20.717-4.005,4.628-9.981,5.384-12.945,5.657-9.777.9-19.537-4.243-25.892-11.62-6.686-7.762-6.827-17.872-8.294-27.563-2.318-15.252-7.3-29.781-16.762-42.012-12.993-16.779-34.47-16.715-52.682-23.063-.647-.225-6.623-2.057-6.623-2.491q.237-6.75.268-13.854c0-6.172-.094-12.15-.315-17.92a71.118,71.118,0,0,0,32.2,15.83A77.978,77.978,0,0,0,122.93,428c30.149,0,56.167-18.113,68.309-44.149a78.537,78.537,0,0,0,6.985-25.667c.236-2.411.378-4.838.378-7.313a77.96,77.96,0,0,0-6.938-32.24V318.6a77.355,77.355,0,0,0-22.375-28.688q-9.54-7.553-.031-.016a74.431,74.431,0,0,0-40.966-15.991c-1.766-.128-3.548-.209-5.345-.209-33.035,0-61.2,21.7-71.51,51.848H86.568L43.3,371.044,0,325.545H30.748c7.1-32.224,31.679-59.82,62.411-70.379,19.963-6.863,42.039-6.461,62.049.257a97.088,97.088,0,0,1,31.411,17.486c1.1.916,2.176,1.881,3.233,2.845h.016a101.461,101.461,0,0,1,21.808,29.106.056.056,0,0,0,.016.032,108.443,108.443,0,0,1,10.833,36.628c2.9,26.406-4.084,53.631-22.911,74.075a83.3,83.3,0,0,1-11.827,10.64c-6.528,4.838-12.709,10.366-15.941,17.261a24.645,24.645,0,0,0-1.656,16.442,76.576,76.576,0,0,0,9.949,23.641c4.4,6.879,10.865,12.038,15.642,18.627a45.68,45.68,0,0,1,8.247,20.861Z",
    transform: "translate(0 -124.723)",
    fill: "#ed6c4d"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17938",
    "data-name": "Rectangle 17938",
    width: 34.233,
    height: 0.016,
    transform: "translate(26.838 268.484)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M71.669,511.642a18.439,18.439,0,0,0-17.124,11.893H88.778a18.418,18.418,0,0,0-17.109-11.893",
    transform: "translate(-27.707 -255.051)",
    fill: "#f8984b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M51.917,542.252a18.573,18.573,0,0,0,1.119,6.381h34.58a18.684,18.684,0,0,0-.158-13.243H53.21a19,19,0,0,0-1.293,6.862",
    transform: "translate(-26.372 -266.889)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M55.769,565.155a18.216,18.216,0,0,0,32.341-1.7c.237-.53.457-1.077.662-1.623H54.192a18.847,18.847,0,0,0,1.577,3.327",
    transform: "translate(-27.528 -280.068)",
    fill: "#218b15"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17939",
    "data-name": "Rectangle 17939",
    width: 34.564,
    height: 0.016,
    transform: "translate(26.664 281.743)",
    fill: "#218b15"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765",
    clipPath: "url(#clip-path)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M385.627,209.4c-3.111,5.005-4.725,6.909-7.968,11.341-1.052,1.437-2.761,5.327-4.434,6.76-3.314,2.835-6.917,5.8-9.082,8.131a26.707,26.707,0,0,1-8.453,6.159c-7.906,3.6-10.138,2.453-10.389-1.372-.775-11.589,28.536-56.307,28.536-56.307s10.014,11.274,14.013,20.793a26.134,26.134,0,0,1-2.223,4.493",
    transform: "translate(-175.393 -91.778)",
    fill: "#d0846a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M558.6,820.7a3.261,3.261,0,0,1,0,2.007c-.654,1.443-5.211,11.335-10.93,9.07s-7.475-6.253-12.39-11.206-10.931-6.088-9.29-10.233Z",
    transform: "translate(-267.043 -403.949)",
    fill: "#6a3514"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M555.77,816.258s2.793,1.425,3.112,2.979-5.211,11.335-10.93,9.068-7.476-6.253-12.39-11.206-12.2-6.5-8.072-9.695Z",
    transform: "translate(-267.326 -402.487)",
    fill: "#662b1d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M528.171,779.3a24.379,24.379,0,0,1-1.5,6.4c-1.186,2.765-.509,5.528,4.406,7.256,0,0,4.235,1.208,5.933,3.455s4.235,7.944,7.795,7.944c0,0,3.389,3.628,5.082,3.108,0,0,2.118-.389,2.118-2.246,0,0,1.948-.473,1.609-1.683l-.294-.475s2.415.128,1.988-1.686l-.171-.325s2.035-.192,1.738-1.574l-.187-.442a1.449,1.449,0,0,0,1.595-1.859s-.315-.237-1-.711c0,0-1.173-.972-2.19-1.911s-3.485-3.044-5.041-4.5a117.324,117.324,0,0,1-9.28-10.4c-1.3-2.01-.92-9.619-.92-9.619l-12.233-1.491s1,7.471.542,10.753",
    transform: "translate(-267.275 -383.119)",
    fill: "#d0846a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M581.663,830.6c-.318.533,1.651,1.116,1.651,1.116a3.464,3.464,0,0,0,.9-.237c-.617-.014-.956-.818-1.256-1.144-.452-.486-.979-.269-1.3.264",
    transform: "translate(-295.446 -413.785)",
    fill: "#aa6650"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M585.71,826.311c-.37.432.742,1.025,1.191,1.307a2.007,2.007,0,0,0,1.116-.285c-.534-.173-1.013-.991-1.22-1.237-.319-.378-.716-.217-1.087.216",
    transform: "translate(-297.482 -411.699)",
    fill: "#aa6650"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M579.839,835.245a3.336,3.336,0,0,0,1.23-.194c-.656-.222-1.353-1.244-1.75-1.632-.583-.566-.954-.3-.954.272s1.191,1.455,1.474,1.555",
    transform: "translate(-293.788 -415.299)",
    fill: "#aa6650"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M572.306,833a1.8,1.8,0,0,0-1.588.622c-.133.324,1.64,2.292,2.385,2.375s1.533,1.338,1.533,1.338a3.337,3.337,0,0,0,1.249-.621c-1.738.775-3.132-3.553-3.579-3.714",
    transform: "translate(-289.901 -415.228)",
    fill: "#aa6650"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M413.116,820.7a3.269,3.269,0,0,0,0,2.007c.653,1.443,5.209,11.335,10.928,9.07s7.478-6.253,12.393-11.206,10.931-6.088,9.293-10.233Z",
    transform: "translate(-209.762 -403.949)",
    fill: "#6a3514"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M416.391,816.258s-2.794,1.425-3.113,2.979,5.209,11.335,10.928,9.068,7.479-6.253,12.393-11.206,12.2-6.5,8.071-9.695Z",
    transform: "translate(-209.923 -402.487)",
    fill: "#662b1d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M444.459,779.3a24.356,24.356,0,0,0,1.495,6.4c1.186,2.765.509,5.528-4.406,7.256,0,0-4.234,1.208-5.932,3.455s-4.235,7.944-7.795,7.944c0,0-3.389,3.628-5.083,3.108,0,0-2.12-.389-2.12-2.246,0,0-1.946-.473-1.609-1.683l.3-.475s-2.415.128-1.99-1.686l.171-.325s-2.034-.192-1.738-1.574l.189-.442a1.451,1.451,0,0,1-1.6-1.859s.316-.237,1-.711c0,0,1.175-.972,2.192-1.911s3.486-3.044,5.039-4.5a116.884,116.884,0,0,0,9.279-10.4c1.3-2.01.921-9.619.921-9.619L445,768.552s-1,7.471-.541,10.753",
    transform: "translate(-210.445 -383.119)",
    fill: "#d0846a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M424.022,815.589s1.306-1.288,2.3-2.347c3.312-.9,9.786,1.173,9.786,1.173s15.295-1.016,10.38.711c0,0-4.234,1.207-5.932,3.455s-4.235,7.945-7.794,7.945c0,0-3.39,3.628-5.084,3.108a3.1,3.1,0,0,1-1.706-1.008c.957.249,2.806.56,3.513-.5.972-1.458,2.083-2.983,2.562-2.894s5.347-1.618,5.292-4.026-7.278-4.212-13.32-5.617",
    transform: "translate(-215.388 -405.284)",
    fill: "#7d3e2c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M421.5,830.6c.318.533-1.65,1.116-1.65,1.116a3.483,3.483,0,0,1-.9-.237c.619-.014.958-.818,1.256-1.144.453-.486.983-.269,1.3.264",
    transform: "translate(-212.81 -413.785)",
    fill: "#aa6650"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M417.674,826.311c.369.432-.741,1.025-1.189,1.307a2.01,2.01,0,0,1-1.117-.285c.534-.173,1.013-.991,1.218-1.237.319-.378.716-.217,1.088.216",
    transform: "translate(-210.992 -411.699)",
    fill: "#aa6650"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M423.211,835.245a3.342,3.342,0,0,1-1.231-.194c.656-.222,1.353-1.244,1.753-1.632.581-.566.951-.3.951.272s-1.191,1.455-1.473,1.555",
    transform: "translate(-214.35 -415.299)",
    fill: "#aa6650"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M428.191,833a1.806,1.806,0,0,1,1.589.622c.132.324-1.642,2.292-2.385,2.375s-1.535,1.338-1.535,1.338a3.355,3.355,0,0,1-1.249-.621c1.741.775,3.131-3.553,3.58-3.714",
    transform: "translate(-215.687 -415.228)",
    fill: "#aa6650"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M431.629,828a91.569,91.569,0,0,1,7.195-8.683l-1.151-1.173s-5.181,7.041-6.043,9.857",
    transform: "translate(-219.252 -407.842)",
    fill: "#7d3e2c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M557.436,815.589s-1.306-1.288-2.3-2.347c-3.312-.9-9.786,1.173-9.786,1.173s-15.295-1.016-10.38.711c0,0,4.234,1.207,5.932,3.455s4.235,7.945,7.794,7.945c0,0,3.39,3.628,5.084,3.108a3.1,3.1,0,0,0,1.706-1.008c-.957.249-2.806.56-3.512-.5-.972-1.458-2.083-2.983-2.562-2.894s-5.347-1.618-5.292-4.026,7.278-4.212,13.32-5.617",
    transform: "translate(-271.25 -405.284)",
    fill: "#7d3e2c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M566.6,828a91.567,91.567,0,0,0-7.194-8.683l1.151-1.173s5.181,7.041,6.043,9.857",
    transform: "translate(-284.159 -407.842)",
    fill: "#7d3e2c"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M493.291,532.318a90.761,90.761,0,0,1-.884-20.961c1.533-22.426,1.135-60.352,1.135-60.352-.567-17.187-7.988-18.365-7.988-18.365s-24.059,8.917-37.182,9.474c-15.857-.557-37.182-8.917-37.182-8.917s-5.228,1.482-5.794,18.669c0,0-1.131,37.806-.211,60.493a103.229,103.229,0,0,1-1.444,21.165,18.079,18.079,0,0,0-.217,3.9,56.524,56.524,0,0,1-.766,12.994c-3.31,18.2-10.026,60.469-2.012,65.4,6.006,3.7,25.939,5.079,31.342.549,3.816-3.2,4.658-4.14,5.647-15.27,1.468-16.512,7-62.951,11.061-104.267,3.737,40.3,9.035,86.261,10.534,103.133.99,11.128,1.832,12.068,5.648,15.269,5.4,4.529,24.25,3.64,30.255-.06,7.5-4.621,2.653-42.289-.484-62.137a104.1,104.1,0,0,1-1.225-17.584,17.817,17.817,0,0,0-.234-3.138",
    transform: "translate(-201.645 -215.67)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M430.613,577.511c2.156-.943,12.15-16.723,17.443-25.26.047-.417.092-.834.138-1.255-5.373,6.854-16.073,19.825-20.124,19.825-5.506,0-14.985-22.664-14.985-22.664l1-17.482c.843.43,19.488,22.661,20.969,22.23S418.4,529.376,418.4,529.376c-1.417-1.942-2.54-14.246-2.54-14.246,4.095,8.419,18.413,18.682,18.413,18.682s-16.578-21.488-17.848-25.156,0-28.71,0-28.71c0,3.241,1.975,21.834,1.975,21.834,2.183,8.018,10.307,15.077,10.307,15.077-6.776-9.5-12.282-47.269-12.282-47.269,7.894,35.61,14.4,35.829,14.4,35.829-5.508-7.122-12.427-45.974-12.427-45.974l5.626-38.745,6.495-10.983-3.126-7.757a71.377,71.377,0,0,0-7.737,3.29s-1.678,14.727-2.244,31.914c0,0-6.064,52.63-4.613,70.639a13.331,13.331,0,0,1-1.077,6.393,17.865,17.865,0,0,0-.889,11.259,10.366,10.366,0,0,1,.262,2.792c-.395,8.471-2.058,50.474,2.825,67.534a16.511,16.511,0,0,0,14.786-.785c9.548-5.048,14.785-15.949,17.122-22.241q.145-1.375.3-2.828c-5.115,7.349-18.944,21.135-23.774,18.593-5.29-2.783-10.563-22.506-10.563-22.506,2.567,1.023,15.856,12.792,18.821,11.5",
    transform: "translate(-208.43 -200.374)",
    fill: "#e6e6e6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M396.056,589.385s10.992,8.084,16.674,7.8,19.821-5.087,21.694-7.556c1.5-1.975-.693-83.242-1.068-91.3s2.451-66.589,5.678-78.431c1.452-5.329,4.765-6.708,7.97-6.613,4.286.127,7.792,3,8.436,6.654,2.023,11.481,7.547,44.6,9.981,76.952,2.425,32.288,2.517,74.061,2.462,88.971-.012,3.411,2.291,6.509,5.892,7.929a27.694,27.694,0,0,0,17.631.828l5.458-1.746a6.535,6.535,0,0,0,1.175-.507c.387-.2,1.555.144.581,4.828a38.074,38.074,0,0,1-4.281,10.831,3.244,3.244,0,0,1-2.011,1.454l-.024.006c-19.2,5.03-37.013-4.93-38.823-23.811l-3.309-78.248-5.225,77.961-1.255,4.152c-2.9,9.612-11.271,17.3-22.218,20.417l-3.895,1.109a8.155,8.155,0,0,1-3.18.252c-3.36-.4-10.978-1.479-15.141-3.548a3.155,3.155,0,0,1-1.8-2.518Z",
    transform: "translate(-201.182 -206.016)",
    fill: "#e6e6e6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M489.926,118.167H471.442c.457,20.938-11.152,24.238-11.152,24.238,7.112,10.577,20.4,10.946,20.4,10.946s14.514.218,21.626-10.359c0,0-12.84-3.887-12.386-24.825",
    transform: "translate(-233.81 -58.906)",
    fill: "#bc7461"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M505.942,144.273c-1.805-3.166-5.93-11.156-6.314-17.5H480.973a36.834,36.834,0,0,1-1.753,9.558c3.259,8.37,15.1,25.605,26.722,7.939",
    transform: "translate(-243.426 -63.197)",
    fill: "#a35d4b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M499.8,174.1c-1.283-.442-30.785-10.316-30.785-10.316-2.367,4.245-6.829,9.879-11.885,10.352a50.046,50.046,0,0,1-12.364-.435c-4.65-.747-8.725-6.157-11.253-9.917,0,0-29.5,9.874-30.782,10.316s-.855,23.483,4.274,40.761c0,0,3.811,14.738,1.14,28.776-1.268,6.67-5.729,24.46-4.547,30.809.155.832,3.849,15.726,4.427,24.294.126,1.87,3.973,2.977,5.813,3.679,5.332,2.032,17.185,6.352,30.42,9.894a28.2,28.2,0,0,0,14.085.1,248.661,248.661,0,0,0,30.438-9.961c1.791-.72,6.643-1.828,6.769-3.662.364-5.336,2.523-16.195,3.17-24.991.486-6.6-2.977-18.29-4.337-24.777-3.371-16.086,1.141-34.162,1.141-34.162,5.131-17.278,5.558-40.315,4.276-40.761",
    transform: "translate(-204.261 -81.644)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M482.253,355.737c.1-.094.2-.186.276-.274.432-.482.294-.327-.276.274",
    transform: "translate(-244.967 -177.055)",
    fill: "#c8a977"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M542.849,76.272s2.9-5.861,6.245-4.133c1.877.968.162,16.366-6.245,15.622,0,0-1.136-.412-1.217-2.892Z",
    transform: "translate(-275.129 -35.802)",
    fill: "#d0846a"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2743",
    "data-name": "Group 2743",
    transform: "translate(268.164 38.255)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2742",
    "data-name": "Group 2742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2741",
    "data-name": "Group 2741",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M549.321,76.3s1.815,5.89-.653,7.285c0,0-1.313.455-1.236,1.093s-.513,4.905-1.991,3.542c0,0-1.143-1.94.282-2.666s.414-.756-.715-2.3c0,0,2.112-7.382,4.312-6.951",
    transform: "translate(-545.008 -76.28)",
    fill: "#a5644f"
  }))))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M549.625,80.308a18.574,18.574,0,0,0-.423-3.145,2.765,2.765,0,0,0-.259-.661c-.133-.181-.2-.191-.279-.151-.157.033-.178.106-.237.146s-.158.153-.235.224a5.815,5.815,0,0,0-.478.564,15.719,15.719,0,0,0-1.568,2.657,12,12,0,0,0-.578,1.42,6.51,6.51,0,0,0-.192.714,3.133,3.133,0,0,0-.044.64l-.119-.234a6.454,6.454,0,0,1,1.076,1.55,1.843,1.843,0,0,1,.156.536.826.826,0,0,1-.229.715,1.11,1.11,0,0,1-.559.215l-.209.042a.382.382,0,0,1-.1.048,1.435,1.435,0,0,0-.423,1.343,1.884,1.884,0,0,0,.807,1.423A1.889,1.889,0,0,1,544.587,87a2.378,2.378,0,0,1-.082-.966,1.822,1.822,0,0,1,.155-.5,1.43,1.43,0,0,1,.356-.436,2.935,2.935,0,0,1,.282-.156l.212-.067c.193-.051.215-.072.245-.1-.02-.023.013,0-.022-.105a1.189,1.189,0,0,0-.13-.3,6.871,6.871,0,0,0-1.017-1.269l-.1-.1-.019-.134a3.235,3.235,0,0,1,.007-.962,7.544,7.544,0,0,1,.208-.84,10.1,10.1,0,0,1,.614-1.554,13.163,13.163,0,0,1,1.769-2.783,5.707,5.707,0,0,1,.59-.615,3.4,3.4,0,0,1,.376-.28,1.416,1.416,0,0,1,.469-.2l.1-.021a.479.479,0,0,1,.227.012.612.612,0,0,1,.307.124,1.181,1.181,0,0,1,.361.428,3.277,3.277,0,0,1,.242.858,7.741,7.741,0,0,1,.059,1.649,12.4,12.4,0,0,1-.167,1.613",
    transform: "translate(-276.553 -37.694)",
    fill: "#975238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M551.239,83.329a7.79,7.79,0,0,0-.4-2.2,2.448,2.448,0,0,0-.731-1.136.951.951,0,0,0-.328-.158l-.125-.036.279-.928.226.12a1.822,1.822,0,0,1,.5.412,3.139,3.139,0,0,1,.638,1.611,7.886,7.886,0,0,1-.067,2.313",
    transform: "translate(-279.207 -39.318)",
    fill: "#975238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M452.189,76.272s-2.9-5.861-6.245-4.133c-1.879.968-.164,16.366,6.245,15.622,0,0,1.133-.412,1.215-2.892Z",
    transform: "translate(-226.158 -35.802)",
    fill: "#d0846a"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2746",
    "data-name": "Group 2746",
    transform: "translate(220.629 38.255)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2745",
    "data-name": "Group 2745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2744",
    "data-name": "Group 2744",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M449.04,76.3s-1.813,5.89.654,7.285c0,0,1.31.455,1.237,1.093s.511,4.905,1.987,3.542c0,0,1.144-1.94-.281-2.666s-.415-.756.714-2.3c0,0-2.112-7.382-4.311-6.951",
    transform: "translate(-448.399 -76.28)",
    fill: "#a5644f"
  }))))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M448.3,80.307a12.8,12.8,0,0,1-.168-1.613,7.762,7.762,0,0,1,.06-1.648,3.262,3.262,0,0,1,.242-.858,1.162,1.162,0,0,1,.361-.428.612.612,0,0,1,.307-.124.486.486,0,0,1,.227-.012l.1.021a1.435,1.435,0,0,1,.468.2,3.363,3.363,0,0,1,.376.28,5.792,5.792,0,0,1,.59.615,13.191,13.191,0,0,1,1.77,2.783,10.127,10.127,0,0,1,.614,1.553,7.492,7.492,0,0,1,.208.84,3.178,3.178,0,0,1,.009.961l-.02.135-.1.1a6.859,6.859,0,0,0-1.018,1.269,1.2,1.2,0,0,0-.131.3c-.035.105,0,.083-.023.1a.581.581,0,0,0,.245.1l.213.067a2.751,2.751,0,0,1,.281.157,1.417,1.417,0,0,1,.356.435,1.843,1.843,0,0,1,.155.5,2.372,2.372,0,0,1-.082.967,1.889,1.889,0,0,1-1.143,1.352,1.888,1.888,0,0,0,.807-1.423,1.435,1.435,0,0,0-.423-1.344.4.4,0,0,1-.1-.048l-.209-.042a1.1,1.1,0,0,1-.558-.216.823.823,0,0,1-.227-.715,1.841,1.841,0,0,1,.157-.536,6.491,6.491,0,0,1,1.077-1.55l-.119.235a3.129,3.129,0,0,0-.045-.64,6.438,6.438,0,0,0-.192-.714,12.14,12.14,0,0,0-.578-1.421,15.789,15.789,0,0,0-1.569-2.656,5.827,5.827,0,0,0-.478-.565c-.077-.071-.179-.185-.236-.225s-.079-.112-.236-.145c-.079-.04-.144-.03-.278.151a2.674,2.674,0,0,0-.258.661,18.43,18.43,0,0,0-.424,3.145",
    transform: "translate(-227.628 -37.694)",
    fill: "#975238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M450.478,83.329a7.866,7.866,0,0,1-.064-2.314,3.131,3.131,0,0,1,.638-1.61,1.826,1.826,0,0,1,.5-.412l.226-.12.279.928-.125.036a.934.934,0,0,0-.328.158,2.449,2.449,0,0,0-.732,1.136,7.808,7.808,0,0,0-.4,2.2",
    transform: "translate(-228.764 -39.318)",
    fill: "#975238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M475.938,83.262s-11.012-7.554-14.4-12.087c-3.092-4.137-5.229-23.107-5.576-26.384-.011-.109-.024-.218-.034-.327s-.017-.161-.017-.161l0,0c-.059-.678-.094-1.362-.094-2.055a22.452,22.452,0,1,1,44.895,0,23.534,23.534,0,0,1-.126,2.433v0s-2.2,21.96-5.591,26.492-14.4,12.087-14.4,12.087a5.845,5.845,0,0,1-4.657,0",
    transform: "translate(-231.539 -9.657)",
    fill: "#d0846a"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M494.2,118.589c-4.022-.066-7.308-.423-7.308-.423.432,2.06,4.08,2.781,7.308,2.788s6.87-.728,7.3-2.788c0,0-3.285.357-7.3.423",
    transform: "translate(-247.321 -58.905)",
    fill: "#d0e4eb"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M496.326,126.093a14.424,14.424,0,0,0,5.486,0,3.747,3.747,0,0,1-5.486,0",
    transform: "translate(-252.116 -62.857)",
    fill: "#a35d4b"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2749",
    "data-name": "Group 2749",
    transform: "translate(234.34 24.474)",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2748",
    "data-name": "Group 2748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2747",
    "data-name": "Group 2747",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M476.265,48.8s1.305,3.8,6.39,4.445,21.151-.035,22.832,2.987,6.154,12.14,6.154,12.14L509.658,49.51Z",
    transform: "translate(-476.265 -48.801)",
    fill: "#975238"
  }))))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M512.423,71.023s-.36.305-.869.8a24.33,24.33,0,0,0-1.8,1.894c-.325.353-.583.749-.863,1.1-.263.362-.452.731-.647,1.038a2.281,2.281,0,0,0-.2.446c-.053.137-.1.257-.137.355-.076.2-.12.314-.12.314s.025-.119.067-.326c.022-.105.048-.234.079-.38a2.439,2.439,0,0,1,.128-.489c.142-.337.277-.755.484-1.169s.425-.862.693-1.271a28.872,28.872,0,0,1,2.281-3.221Z",
    transform: "translate(-257.939 -34.95)",
    fill: "#975238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M480.916,66.534s-.367,2.959-1.451,3.209c-3.033.7-8.45-2.58-12.966.967,0,0,1-3.5,3.637-4.39s9.9.7,10.779.214",
    transform: "translate(-236.964 -32.921)",
    fill: "#1a1a1a"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M510.4,66.534s.368,2.959,1.451,3.209c3.033.7,8.45-2.58,12.966.967,0,0-1-3.5-3.639-4.39s-9.9.7-10.778.214",
    transform: "translate(-259.264 -32.921)",
    fill: "#1a1a1a"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M504.426,90.051a70.572,70.572,0,0,0-.127,7.172c.093,1.572-.69,2.479-1.428,2.64,0,0,3.1.5,3.569-2.477.315-2-1.537-4.2-2.015-7.335",
    transform: "translate(-255.44 -44.89)",
    fill: "#a5644f"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M496.956,108.51s-2.972-1.058-2.482-.118,2.482.118,2.482.118",
    transform: "translate(-251.147 -53.839)",
    fill: "#975238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M500.276,16.189c-5.356-16.014-44-22.777-45.14-7.992a4.259,4.259,0,0,0-4.069,2.307c-4.338,8.579-1.626,24.294-.732,25.867,0,0,2.239,1.212,3.157,5.947,0,0,1.91-2.141,2.332-6.679s1.166-5.8,2.8-8.981a17.26,17.26,0,0,0,2.188-6.764c1.163.51,2.257,1.942,5.725,1.728,10.28-.641,24.137-.936,25.888,5.9,2.41,9.391,3.538,12.779,3.538,12.779s1.381-2.994,3.27-3.931c0,0,3.181-13.79,1.044-20.183",
    transform: "translate(-227.91 0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M473.337,19.351c-4.657.109-6.562-6.475-7.623-11.007-.563-2.407,2.19-5.3,4.893-7.483-5.027.93-8.61,3.414-8.946,7.765-1.186-.013,5.562,14.322,5.677,11.7,1.162.51,2.258,1.942,5.725,1.728,10.28-.641,24.571-1.037,25.888,5.9a169.845,169.845,0,0,1,2.444,18.91s1.437-6.936,1.64-7.245c4-31.86-25.088-20.372-29.7-20.266",
    transform: "translate(-234.436 -0.429)",
    fill: "#1a1a1a"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M462.941,85.024s.31-.083.765-.214,1.061-.243,1.657-.421a8.425,8.425,0,0,0,.885-.206c.272-.1.536-.158.76-.227.454-.121.778-.174.778-.174a7.94,7.94,0,0,1-.688.4c-.215.1-.462.243-.739.359a8.357,8.357,0,0,1-.9.267c-.313.062-.622.136-.916.185s-.577.039-.814.058a3.8,3.8,0,0,1-.792-.026",
    transform: "translate(-235.157 -41.765)",
    fill: "#a35d4b"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M466.22,86.393s.176-.1.418-.248c.247-.13.567-.3.885-.482a2.26,2.26,0,0,0,.477-.241c.142-.095.295-.156.418-.223a3.462,3.462,0,0,1,.453-.18,3,3,0,0,1-.31.375,2.952,2.952,0,0,1-.846.653l-.522.225a3.515,3.515,0,0,1-.489.106,1.469,1.469,0,0,1-.483.015",
    transform: "translate(-236.823 -42.382)",
    fill: "#a35d4b"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M481.286,82.352a1.9,1.9,0,0,0,.179-1.232c-.159-.618-5.692-5.34-9.38.416,0,0,3.335,2.715,9.2.816",
    transform: "translate(-239.802 -39.237)",
    fill: "#d0e4eb"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M480.936,82.982A2.417,2.417,0,0,0,481,79.024v0c-.166-.053-.333-.1-.5-.145a.1.1,0,0,1-.022-.006c-.171-.042-.349-.077-.528-.1h0a5.159,5.159,0,0,0-.531-.049h-.034a4.523,4.523,0,0,0-.553.012,2.411,2.411,0,0,0-.594,4.166,10.933,10.933,0,0,0,2.7.084",
    transform: "translate(-242.443 -39.24)",
    fill: "#2c1117"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M482.041,82.112a1.11,1.11,0,1,1-1.111-1.131,1.119,1.119,0,0,1,1.111,1.131",
    transform: "translate(-243.733 -40.369)",
    fill: "#040000"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M479.992,81.03a.561.561,0,1,1-.56-.571.567.567,0,0,1,.56.571",
    transform: "translate(-243.248 -40.108)",
    fill: "#d0e4eb"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M481.29,81.232a1.386,1.386,0,0,0-.191-.668,4.881,4.881,0,0,0-.539-.383,9.919,9.919,0,0,0-1.242-.642,7.53,7.53,0,0,0-2.585-.629,5,5,0,0,0-2.472.533A10.584,10.584,0,0,0,472,81.069l-.035-.189.926.765-1.072-.542-.111-.056.077-.132a5.3,5.3,0,0,1,1.912-2.455,4.694,4.694,0,0,1,3.111-.819,6.113,6.113,0,0,1,2.947,1.085,6.188,6.188,0,0,1,1.164,1.026,2.839,2.839,0,0,1,.464.689,1.3,1.3,0,0,1-.093.792",
    transform: "translate(-239.611 -38.693)",
    fill: "#1a1a1a"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M537.022,85.024a3.8,3.8,0,0,1-.792.026c-.236-.018-.517-.021-.812-.058s-.6-.122-.916-.185a8.415,8.415,0,0,1-.895-.266c-.279-.117-.526-.257-.741-.36-.425-.223-.687-.4-.687-.4s.324.052.776.174c.224.069.491.128.76.228a8.537,8.537,0,0,0,.886.2c.6.179,1.2.3,1.655.421s.765.214.765.214",
    transform: "translate(-270.328 -41.765)",
    fill: "#a35d4b"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M536,86.393a1.455,1.455,0,0,1-.482-.016,3.433,3.433,0,0,1-.489-.105l-.523-.226a2.952,2.952,0,0,1-.844-.652,2.99,2.99,0,0,1-.31-.375,3.468,3.468,0,0,1,.453.18,4.658,4.658,0,0,1,.418.222,2.145,2.145,0,0,0,.477.241c.316.185.637.353.884.482.241.148.417.248.417.248",
    transform: "translate(-270.926 -42.382)",
    fill: "#a35d4b"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M513.952,82.352a1.912,1.912,0,0,1-.18-1.232c.161-.618,5.693-5.34,9.381.416,0,0-3.334,2.715-9.2.816",
    transform: "translate(-260.956 -39.237)",
    fill: "#d0e4eb"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M519.16,82.982a2.419,2.419,0,0,1-.07-3.958l0,0c.164-.053.333-.1.5-.145a.064.064,0,0,0,.021-.006c.174-.042.351-.077.53-.1h0c.176-.026.352-.041.532-.049h.033a4.557,4.557,0,0,1,.555.012,2.414,2.414,0,0,1,.595,4.166,10.948,10.948,0,0,1-2.7.084",
    transform: "translate(-263.174 -39.24)",
    fill: "#2c1117"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M520.636,82.112a1.108,1.108,0,1,0,1.108-1.131,1.119,1.119,0,0,0-1.108,1.131",
    transform: "translate(-264.464 -40.369)",
    fill: "#040000"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M523.818,81.03a.56.56,0,1,0,.56-.571.567.567,0,0,0-.56.571",
    transform: "translate(-266.08 -40.108)",
    fill: "#d0e4eb"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M513.659,81.231a1.3,1.3,0,0,1-.093-.792,2.768,2.768,0,0,1,.463-.689,6.172,6.172,0,0,1,1.164-1.026,6.106,6.106,0,0,1,2.946-1.085,4.693,4.693,0,0,1,3.111.819,5.306,5.306,0,0,1,1.912,2.455l.077.132-.111.056-1.072.542.925-.765-.034.189a10.6,10.6,0,0,0-2.261-1.626,4.991,4.991,0,0,0-2.472-.533,7.533,7.533,0,0,0-2.584.63,9.968,9.968,0,0,0-1.241.642,4.843,4.843,0,0,0-.54.383,1.366,1.366,0,0,0-.189.668",
    transform: "translate(-260.858 -38.693)",
    fill: "#1a1a1a"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M455.488,14.909c-.039.235-.07.473-.09.72-.289,0,6.752,15.083-2.832,23.568C450.3,41.205,450.584,24.08,451,18.266c-4.276,8.646-1.519,23.983-.6,25.538a41.73,41.73,0,0,1,4.236,9.5,35.659,35.659,0,0,0,1.474-10.235c-.226-4.552,1.213-5.8,2.913-8.982a16.9,16.9,0,0,0,2.274-6.713c-1.582-4.041-4.357-9.622-5.812-12.468",
    transform: "translate(-227.913 -7.432)",
    fill: "#1a1a1a"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2752",
    "data-name": "Group 2752",
    transform: "translate(234.693 0.001)",
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2751",
    "data-name": "Group 2751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2750",
    "data-name": "Group 2750",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M514.677,30.551c.677-4.54,1.209-10.677-.021-14.363C511.214,5.9,494.034-.566,481.889.041c-3.61,1.843-6.848,4.537-3.508,7.437,6.093,5.292,40.434-3.355,36.3,23.074",
    transform: "translate(-476.983 -0.002)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M553.389,61.642c.029-.2.061-.393.093-.594-.033.2-.064.4-.093.594",
    transform: "translate(-515.794 -30.433)",
    fill: "#4d4d4d"
  }))))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M565.7,541.714a17.652,17.652,0,0,0-1.155-10.421,11.382,11.382,0,0,1-.894-5.93c1.774-15.721-4.593-77.019-5.581-85.367-.015-.122-.307,0-.427,0h-.428a.453.453,0,0,0-.428.436c-.687,9.342.179,32.5.3,33.178.215,1.187,4.6,28.111,4.6,28.111l-6.081,18.436,2.5,8.207-16.761-9.534s8.2,10.79,10.17,12.088,10.819,3.964,12.469,7.553a5.174,5.174,0,0,1-1.293,6.044l-13.707-3.239-10.532-18.992s5.931,21.153,7.2,21.153,16.284,5.828,17.036,6.475-2,20.287-2,20.287l-10.219,6.142-10.407-18.875s6.791,22.664,9.261,24.392,15.164-9,15.164-9-5.563,16.771-12.2,20.008l-10.944-10.793s7.2,14.114,10.944,15.907,11.695-12.021,11.695-12.021v19.392c2.693-18.187,1.766-47.774,1.344-57.866a26.545,26.545,0,0,1,.373-5.771",
    transform: "translate(-273.516 -219.309)",
    fill: "#e6e6e6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M427.1,320.541s5.473,4.425,15.431,7.752c-14.031-2.151-28.69-5.811-28.69-5.811-4.9-13.522-5.687-40.906-2.537-34.472.061-5.5,8.158-18.537,7.469-25.3-.443-4.369-3.007-22.906-1.624-23.095.011,0,5.3-27.626,7.2-28.061s-3.811,35.184-2.122,36.911,9.963-26.98,10.17-19.857-11.652,31.516-9.323,32.374,14.009-12.3,13.145-8.2-12.1,15.321-12.516,15.967-.836,11.23,1.914,13.387,2.543,11.007,2.543,11.007,13.927-6.075,17.1-9.006c-2.751,2.915-15.622,16.363-22.818,19.578,0,0-1.055,4.537.847,6.911s3.385,7.089,3.811,9.909",
    transform: "translate(-207.971 -105.458)",
    fill: "#e6e6e6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M455.024,43.546l.4-4.495a15.4,15.4,0,0,0-.159-3.406.71.71,0,0,0-.346-.6c-.586-.293-.99-.907-.515-9.256a3.618,3.618,0,0,1,4.97,2.922c.907,7.644-2.93,14.89-4.351,14.834",
    transform: "translate(-230.715 -12.719)",
    fill: "#333"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M538.359,310.014s-5.473,4.722-15.431,8.272c14.031-2.3,29.618-6.636,29.618-6.636,5.569-5.758,3.887-32.266,2.114-31.886-.06-5.863-11.648-85.581-13.551-86.045s3.811,37.544,2.122,39.387-9.963-28.79-10.17-21.189,11.652,33.63,9.322,34.546-14.009-13.125-13.145-8.748,12.1,16.348,12.516,17.038.836,11.984-1.914,14.285-2.543,11.746-2.543,11.746-13.927-6.482-17.1-9.611c2.75,3.11,15.622,17.461,22.818,20.892,0,0,1.056,4.841-.847,7.375s-3.385,7.565-3.811,10.574",
    transform: "translate(-264.243 -96.566)",
    fill: "#e6e6e6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M443.669,285.438c-.243-.11-.458-.247-.7-.385l.431-.577a8.974,8.974,0,0,0,.27.961",
    transform: "translate(-225.012 -141.81)",
    fill: "#d0846a"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M577.609,183.142a22.692,22.692,0,0,0-3.8-1.293c-12.924,8.884-14.394,20.167-16.961,28.866l-1.868,12.418,20.7,6.432c3.411-3.764,11.374-36.766,1.932-46.423",
    transform: "translate(-281.907 -90.648)",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M386.473,181.427a33.179,33.179,0,0,0-4.439,1.508c-6.777,10.667-13.6,21.342-20.24,34.346-.055.107,22.908,4.174,23.025,4.158.735.019,13.312-22.545,1.654-40.011",
    transform: "translate(-183.778 -90.44)",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M386.5,251.291l-21.667-4.413-1.429-.156c-.074.226-1.462,2.9-1.613,3.108l1.909.5q.174.046.351.077l20.783,3.741Z",
    transform: "translate(-183.778 -122.99)",
    fill: "#ed6c4d"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M574.975,272.721l.862-2.635a.644.644,0,0,0-.43-.822l-20.954-5.9a.629.629,0,0,0-.773.442l-.509,1.815a.645.645,0,0,0,.406.785l20.609,6.722a.627.627,0,0,0,.789-.408",
    transform: "translate(-280.978 -131.275)",
    fill: "#ed6c4d"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    "data-name": "Group 2755",
    transform: "translate(230.276 33.247)",
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2754",
    "data-name": "Group 2754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2753",
    "data-name": "Group 2753",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M486.468,69.728c.28-1.313-.113-2.962-1.485-3.434,1.411.442,1.851,2.108,1.605,3.46l-.12-.027",
    transform: "translate(-476.629 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M487.758,70.158c.28-1.313-.113-2.962-1.486-3.434,1.411.442,1.851,2.108,1.605,3.46l-.12-.027",
    transform: "translate(-477.284 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M489.046,70.158c.28-1.313-.113-2.962-1.485-3.434,1.411.442,1.851,2.108,1.606,3.46l-.12-.027",
    transform: "translate(-477.939 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M490.335,70.158c.28-1.313-.113-2.962-1.485-3.434,1.411.442,1.851,2.108,1.605,3.46l-.12-.027",
    transform: "translate(-478.593 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M491.624,69.725a2.418,2.418,0,0,0-1.487-3,2.477,2.477,0,0,1,1.606,3.031l-.119-.03",
    transform: "translate(-479.248 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M493.239,69.542a1.572,1.572,0,0,0-.952-1.959,1.632,1.632,0,0,1,1.071,1.989l-.119-.03",
    transform: "translate(-480.339 -66.937)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M494.346,68.736c0-.365-.147-.812-.546-.9.422.042.631.5.669.893Z",
    transform: "translate(-481.108 -67.065)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M472.618,69.971a1.572,1.572,0,0,0-.952-1.959A1.632,1.632,0,0,1,472.737,70l-.119-.03",
    transform: "translate(-469.865 -67.15)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M473.724,69.166c0-.365-.147-.812-.545-.9.422.042.631.5.669.893Z",
    transform: "translate(-470.633 -67.279)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M471.267,70.579a1.353,1.353,0,0,0-.89-1.708,1.412,1.412,0,0,1,1.009,1.74l-.119-.032",
    transform: "translate(-469.21 -67.579)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M472.305,69.878a.735.735,0,0,0-.508-.782c.379.027.6.422.631.779l-.123,0",
    transform: "translate(-469.931 -67.691)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M470.17,71.437a1.006,1.006,0,0,0-.653-1.277,1.068,1.068,0,0,1,.772,1.309l-.119-.032",
    transform: "translate(-468.773 -68.221)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M471.379,70.916a.544.544,0,0,0-.366-.587c.287.015.458.313.488.584Z",
    transform: "translate(-469.533 -68.305)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M470.089,71.775a.544.544,0,0,0-.366-.587c.287.015.458.313.489.584Z",
    transform: "translate(-468.878 -68.734)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M469.231,71.775a.545.545,0,0,0-.366-.587c.287.015.458.313.489.584Z",
    transform: "translate(-468.442 -68.734)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M468.8,72.634a.544.544,0,0,0-.366-.587c.287.015.458.313.489.584Z",
    transform: "translate(-468.223 -69.162)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M468.218,72.855a.339.339,0,0,0-.213-.378c.188,0,.309.2.337.375Z",
    transform: "translate(-468.005 -69.376)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M485.18,69.512a2.635,2.635,0,0,0-1.485-3.218A2.694,2.694,0,0,1,485.3,69.54l-.12-.028",
    transform: "translate(-475.975 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M483.891,69.512a2.635,2.635,0,0,0-1.485-3.218,2.693,2.693,0,0,1,1.605,3.246l-.12-.028",
    transform: "translate(-475.32 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M482.6,69.512a2.635,2.635,0,0,0-1.485-3.218,2.694,2.694,0,0,1,1.606,3.246l-.12-.028",
    transform: "translate(-474.665 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M481.614,69.395a2.575,2.575,0,0,0-1.356-3.1c1.285.391,1.7,1.9,1.476,3.127l-.12-.027",
    transform: "translate(-474.229 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M478.985,69.08a2.27,2.27,0,0,0-1.3-2.786,2.327,2.327,0,0,1,1.423,2.815l-.119-.029",
    transform: "translate(-472.92 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M478.125,69.08a2.269,2.269,0,0,0-1.3-2.786,2.327,2.327,0,0,1,1.424,2.815l-.12-.029",
    transform: "translate(-472.483 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M477.266,69.08a2.269,2.269,0,0,0-1.3-2.786,2.327,2.327,0,0,1,1.424,2.815l-.119-.029",
    transform: "translate(-472.047 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M476.407,69.08a2.269,2.269,0,0,0-1.3-2.786,2.327,2.327,0,0,1,1.424,2.815l-.119-.029",
    transform: "translate(-471.61 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M475.548,69.294a2.057,2.057,0,0,0-1.3-2.57,2.269,2.269,0,0,1,.72.353,2.239,2.239,0,0,1,.7,2.248Z",
    transform: "translate(-471.174 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M474.689,69.294a2.057,2.057,0,0,0-1.3-2.57,2.267,2.267,0,0,1,.72.353,2.239,2.239,0,0,1,.7,2.248Z",
    transform: "translate(-470.737 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M473.829,69.506a1.857,1.857,0,0,0-1.305-2.353,2.385,2.385,0,0,1,.694.3,1.95,1.95,0,0,1,.73,2.083l-.119-.034",
    transform: "translate(-470.3 -66.722)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M479.843,69.3a2.5,2.5,0,0,0-1.3-3,2.556,2.556,0,0,1,1.424,3.03l-.12-.027",
    transform: "translate(-473.356 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M480.7,69.3a2.5,2.5,0,0,0-1.3-3,2.556,2.556,0,0,1,1.425,3.03l-.12-.027",
    transform: "translate(-473.792 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M518.115,69.754c-.245-1.352.2-3.018,1.606-3.46-1.373.472-1.766,2.121-1.485,3.434l-.121.027",
    transform: "translate(-493.427 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M516.826,70.183c-.246-1.352.2-3.018,1.606-3.46-1.373.472-1.765,2.121-1.485,3.434l-.121.027",
    transform: "translate(-492.772 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M515.537,70.183c-.246-1.352.195-3.018,1.606-3.46-1.373.472-1.765,2.121-1.485,3.434l-.121.027",
    transform: "translate(-492.117 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M514.248,70.183c-.245-1.352.2-3.018,1.606-3.46-1.373.472-1.765,2.121-1.485,3.434l-.12.027",
    transform: "translate(-491.462 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M512.956,69.755a2.477,2.477,0,0,1,1.606-3.031,2.417,2.417,0,0,0-1.486,3l-.12.03",
    transform: "translate(-490.803 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M511.922,69.572a1.632,1.632,0,0,1,1.071-1.989,1.572,1.572,0,0,0-.951,1.959l-.12.03",
    transform: "translate(-490.292 -66.937)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M511.27,68.733c.037-.39.247-.851.669-.893-.4.083-.547.531-.546.9Z",
    transform: "translate(-489.982 -67.065)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M532.543,70a1.632,1.632,0,0,1,1.071-1.989,1.572,1.572,0,0,0-.951,1.959l-.12.03",
    transform: "translate(-500.767 -67.15)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M531.891,69.162c.038-.39.247-.851.669-.893-.4.083-.547.531-.546.9l-.123,0",
    transform: "translate(-500.457 -67.279)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M533.961,70.611a1.411,1.411,0,0,1,1.009-1.74,1.352,1.352,0,0,0-.89,1.708l-.119.032",
    transform: "translate(-501.488 -67.579)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M533.349,69.875c.035-.357.252-.753.631-.779a.735.735,0,0,0-.508.782l-.123,0",
    transform: "translate(-501.197 -67.691)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M535.314,71.469a1.068,1.068,0,0,1,.772-1.309,1.006,1.006,0,0,0-.652,1.277l-.119.032",
    transform: "translate(-502.181 -68.221)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M534.423,70.913c.031-.271.2-.569.489-.584a.544.544,0,0,0-.366.587l-.123,0",
    transform: "translate(-501.743 -68.305)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M535.712,71.772c.031-.271.2-.569.489-.584a.544.544,0,0,0-.365.587l-.123,0",
    transform: "translate(-502.398 -68.734)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M536.571,71.772c.031-.271.2-.569.489-.584a.544.544,0,0,0-.366.587l-.123,0",
    transform: "translate(-502.834 -68.734)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M537,72.631c.031-.271.2-.569.489-.584a.544.544,0,0,0-.365.587l-.123,0",
    transform: "translate(-503.052 -69.162)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M537.74,72.852c.027-.18.148-.374.336-.375a.338.338,0,0,0-.213.378Z",
    transform: "translate(-503.428 -69.376)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M519.4,69.54a2.694,2.694,0,0,1,1.605-3.246,2.635,2.635,0,0,0-1.485,3.218l-.12.028",
    transform: "translate(-494.079 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M520.691,69.54a2.694,2.694,0,0,1,1.605-3.246,2.635,2.635,0,0,0-1.485,3.218l-.12.028",
    transform: "translate(-494.733 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M521.98,69.54a2.694,2.694,0,0,1,1.605-3.246,2.635,2.635,0,0,0-1.485,3.218l-.12.028",
    transform: "translate(-495.389 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M523.11,69.421c-.227-1.231.192-2.737,1.476-3.127a2.576,2.576,0,0,0-1.356,3.1l-.12.027",
    transform: "translate(-495.966 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M525.794,69.109a2.328,2.328,0,0,1,1.424-2.815,2.269,2.269,0,0,0-1.3,2.786l-.12.029",
    transform: "translate(-497.33 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M526.653,69.109a2.328,2.328,0,0,1,1.424-2.815,2.269,2.269,0,0,0-1.3,2.786l-.12.029",
    transform: "translate(-497.767 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M527.512,69.109a2.327,2.327,0,0,1,1.424-2.815,2.269,2.269,0,0,0-1.3,2.786l-.12.029",
    transform: "translate(-498.203 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M528.371,69.109a2.327,2.327,0,0,1,1.424-2.815,2.269,2.269,0,0,0-1.3,2.786l-.12.029",
    transform: "translate(-498.639 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M529.229,69.324a2.116,2.116,0,0,1,1.424-2.6,2.058,2.058,0,0,0-1.3,2.57l-.119.031",
    transform: "translate(-499.074 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M530.088,69.324a2.116,2.116,0,0,1,1.424-2.6,2.058,2.058,0,0,0-1.3,2.57l-.119.031",
    transform: "translate(-499.511 -66.508)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M530.946,69.54a1.922,1.922,0,0,1,1.423-2.387,1.858,1.858,0,0,0-1.305,2.353l-.118.034",
    transform: "translate(-499.945 -66.722)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M524.936,69.324a2.556,2.556,0,0,1,1.424-3.03,2.5,2.5,0,0,0-1.3,3l-.12.027",
    transform: "translate(-496.895 -66.294)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M524.077,69.324a2.556,2.556,0,0,1,1.425-3.03,2.5,2.5,0,0,0-1.3,3l-.12.027",
    transform: "translate(-496.459 -66.294)",
    fill: "#999"
  }))))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M537.472,64.106a92.67,92.67,0,0,1-6.887,24.485,5.658,5.658,0,0,0-.521,1.59,3.4,3.4,0,0,0,1.1,2.786,7.005,7.005,0,0,0,2.484,1.357l-1.275,7.129a10.139,10.139,0,0,0,5.706,1l.614-2.769q.08.836.159,1.672l4.315.163c.2-4.6-.038-9.207-.278-13.8l-1.363-26.047a13.651,13.651,0,0,0-.687-4.3,3.56,3.56,0,0,0-2.871-2.493c-.42-.013-.325,3.58-.279,4.023a21.59,21.59,0,0,1-.213,5.2",
    transform: "translate(-269.244 -27.357)",
    fill: "#ed6c4d"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M533.133,109.939a4.654,4.654,0,0,0,.45.314c.4-1.041.765-2.1,1.095-3.169a112.8,112.8,0,0,0,3.038-13.949c.228-1.313.457-2.636.627-3.962a66.807,66.807,0,0,1-5.885,17.023,4.105,4.105,0,0,0-.5,1.346,2.8,2.8,0,0,0,1.173,2.4",
    transform: "translate(-270.21 -44.453)",
    fill: "#c15742"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M540.208,116.244a53.631,53.631,0,0,1,.488-6.392c.552-5.416.5-10.921,1.254-16.292q-1.206,6.525-2.93,12.92a53.236,53.236,0,0,0-1.579,6.851l-.031.237.1.034-1.155,6.266c1.479.66,2.615,1.428,4.222,1.451-.577-1.451-.341-3.484-.37-5.075",
    transform: "translate(-272.449 -46.639)",
    fill: "#c15742"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M550.264,105.919c-.129,4.294-2.1,9.249-2.211,13.544a27.39,27.39,0,0,0,.2,5.162v0l.014-.056.075.55c.056.293.116.587.169.881l3.011.153c-2.167-6.181-.8-13.62-1.254-20.238",
    transform: "translate(-278.375 -52.8)",
    fill: "#c15742"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M545.289,69.9a12.339,12.339,0,0,0,.816-2.251q-.094,3.619-.188,7.238.708-3.913,1.418-7.826a39.016,39.016,0,0,1,2.2,10.066q-.308-5.634-.617-11.268a5.726,5.726,0,0,0-.394-2.148,3.348,3.348,0,0,0-1.755-1.478,2.024,2.024,0,0,0-1.049-.292c-1.327.138-.585,1.893-.48,2.892.091.866.113,1.76.119,2.634a8.725,8.725,0,0,1-.067,2.434",
    transform: "translate(-276.807 -30.877)",
    fill: "#c15742"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M447.443,56.088c.346.738.883,1.5,1.66,1.6a2.333,2.333,0,0,0,1.23-.271,37.66,37.66,0,0,0,4.386-2.7,23.876,23.876,0,0,1,17.915-2.794,2.058,2.058,0,0,0-.819-1.3A8.317,8.317,0,0,0,469.2,49.3a38.588,38.588,0,0,0-17.966-1.842c-1.485.2-4.591.67-5.01,2.592a8.473,8.473,0,0,0,.307,2.446,11.015,11.015,0,0,0,.911,3.595",
    transform: "translate(-226.646 -23.483)",
    fill: "#282e7c"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M446.991,55.351a1.562,1.562,0,0,0,.517-.021l7.445-1.128a15.785,15.785,0,0,0-4.978,3.033,81.325,81.325,0,0,1,9.541-2.756,31.7,31.7,0,0,1,10.687-.452c-.334-.537-1.812-.656-2.4-.821A48.121,48.121,0,0,0,454.57,51.76a21.593,21.593,0,0,0-4.85.424,9.624,9.624,0,0,0-3.147,1.045,1.237,1.237,0,0,0,.418,2.122",
    transform: "translate(-226.622 -25.802)",
    fill: "#2e3192"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M446.641,17.094a.61.61,0,0,0-.9-.09,1.809,1.809,0,0,0-.5.914,16.912,16.912,0,0,0-.725,4.413c-.62-.4-1.207.581-1.311,1.338a19.218,19.218,0,0,0,.644,8.17,1.87,1.87,0,0,0,.546.98,1.742,1.742,0,0,0,1.111.241c1.451-.022,2.9-.115,4.351-.186a140.645,140.645,0,0,1,21.17.57,80.109,80.109,0,0,1,21.572,4.85,36.891,36.891,0,0,0,4.75,1.576,1.2,1.2,0,0,0,.835,0c.216-.134.36-.987.418-1.244.774-3.424.684-5.933-1.111-8.9a27.531,27.531,0,0,0-7.085-7.387,59.938,59.938,0,0,0-33-12.269c-2.37-.127-5.088-.113-7.181,1.239a9.616,9.616,0,0,0-3.587,5.789",
    transform: "translate(-225.041 -4.993)",
    fill: "#2e3192"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M498.621,44.3c.774-3.423.665-5.933-1.13-8.9a21.735,21.735,0,0,0-3.292-4.122q-.527-.307-1.057-.6c-13.208-7.342-28.5-9.99-43.411-9.111a126.106,126.106,0,0,1,30.928,7.544c3.01,1.152,6.082,2.491,8.271,4.951l-13.8-4.538a11.289,11.289,0,0,1,3.333,1.752,155.733,155.733,0,0,0-24.821-3.518,94.774,94.774,0,0,1,37.023,10.053c.754.382,1.641,1.111,1.335,1.93a122.575,122.575,0,0,0-15.169-3.827c-9.283-1.515-18.744-.859-28.135-1.1a11.438,11.438,0,0,1-3.961-.593,5.067,5.067,0,0,1-1.669-1.077,19.126,19.126,0,0,0,.785,4.378,1.869,1.869,0,0,0,.546.979,1.742,1.742,0,0,0,1.111.241c1.452-.023,2.9-.115,4.351-.186a140.577,140.577,0,0,1,21.17.57A80.085,80.085,0,0,1,492.6,43.968a37.1,37.1,0,0,0,4.768,1.576,1.2,1.2,0,0,0,.836,0c.216-.133.36-.987.418-1.244",
    transform: "translate(-225.06 -10.668)",
    fill: "#ed6c4d"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M477.75,41.2l-17.741-1.484,5.533,1.227-1.367.19a23.654,23.654,0,0,1,5.712,1.241,197.821,197.821,0,0,0-22.114-.944l9.782-.79-7.813-.91,7.035-.445c-3.9-1.692-8.226-1.792-12.441-1.868l3.506.011a15.84,15.84,0,0,1-2.8-.618,19.48,19.48,0,0,1,5.463-.218c2.214.044,4.426.206,6.628.454A120.005,120.005,0,0,1,470.3,39.394c2.49.568,4.971,1.183,7.449,1.8",
    transform: "translate(-225.707 -18.198)",
    fill: "#0d61d2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M475.913,30.183c-6.774-2.1-13.725-4.094-20.778-3.737a28.685,28.685,0,0,1,4.74,1.252,29.855,29.855,0,0,0-9.228-.224l4.608-.98c-1.836-.4-3.792-.256-5.583-.654.438-1.149,3.024-.67,3.929-.642a54.3,54.3,0,0,1,5.58.46,65.925,65.925,0,0,1,10.882,2.449c1.973.615,3.88,1.466,5.849,2.076",
    transform: "translate(-228.418 -12.5)",
    fill: "#0d61d2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M462.174,13.444c7.346-.309,14.873.824,21.42,4.345-3.143-2.624-7.158-3.741-11.06-4.725a38.817,38.817,0,0,0-4.144-.877,20.633,20.633,0,0,0-11.062,1.569,18.353,18.353,0,0,0-2.848,1.528c1.166-.372,2.208-1.018,3.411-1.315a21.619,21.619,0,0,1,4.283-.525",
    transform: "translate(-230.859 -5.982)",
    fill: "#0d61d2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M533.422,54.159c.428.872,1.77,2.324,2.138,3.051-1.538-1.835-6.159.091-7.7-1.744,1.363,2.261,6.335,1.227,7.7,3.487-2.994-.436-8.98-1.307-11.119-3.051,1.711,3.051,4.7,1.307,7.7,3.487.492.358,3.5,1.188,4.131,1.444.807.325,2.011.95,2.712.735.359-.11.427-1.307.427-1.743,0-1.36,1.163-3.689.428-4.359-.637-.581-2.994.436-3.684.418a9.007,9.007,0,0,1-2.731-1.725",
    transform: "translate(-266.397 -26.998)",
    fill: "#c15742"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M485.012,113.42a28.828,28.828,0,0,1,7.76.065.186.186,0,0,1,.145.185v1.607l-.511-.473a.18.18,0,0,0-.245,0l-.389.36a.18.18,0,0,1-.245,0l-.4-.369a.18.18,0,0,0-.234-.01l-.39.305a.18.18,0,0,1-.219,0l-.434-.325a.179.179,0,0,0-.21,0l-.481.332a.179.179,0,0,1-.219-.012l-.339-.29a.179.179,0,0,0-.24.005l-.393.364a.181.181,0,0,1-.246,0l-.389-.36a.18.18,0,0,0-.245,0l-.511.473a9.641,9.641,0,0,1-1.689-1.6.16.16,0,0,1,.122-.254",
    transform: "translate(-246.29 -56.419)",
    fill: "#333"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M510.312,113.42a28.827,28.827,0,0,0-7.76.065.186.186,0,0,0-.145.185v1.607l.511-.473a.18.18,0,0,1,.245,0l.389.36a.18.18,0,0,0,.245,0l.4-.369a.18.18,0,0,1,.234-.01l.39.305a.18.18,0,0,0,.219,0l.434-.325a.179.179,0,0,1,.21,0l.481.332a.179.179,0,0,0,.219-.012l.339-.29a.179.179,0,0,1,.24.005l.393.364a.18.18,0,0,0,.245,0l.389-.36a.18.18,0,0,1,.245,0l.511.473a9.641,9.641,0,0,0,1.689-1.6.161.161,0,0,0-.122-.254",
    transform: "translate(-255.204 -56.419)",
    fill: "#333"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M427.764,260.13a12.115,12.115,0,0,0-2.382-2.845,10.583,10.583,0,0,0-2.981-2.568c-1.163-.484-6.585.2-6.585.2l4.993-1.312a2.736,2.736,0,0,1,2.278.736c1.292,1.265,2.088,2.669,3.8,3.687.891.53,2.768.351,2.364-1.132-.264-.972-1.263-1.632-1.86-2.368-1.038-1.281-2.1-2.551-3.1-3.86a1.929,1.929,0,0,0-1.711-.759l-6.637.463,4.8-4.229c.04-.038,3.2,1.5,3.455,1.581,1.019.324,4.013,1.4,4.847.132.982-1.489-1.805-2.488-2.628-2.9-1.146-.575-2.389-.951-3.539-1.533-3.62-1.837-5.395.716-8.782,2.963a20.77,20.77,0,0,0-3.46,3.344c-2.883,3.967-4.962,8.707-10.048,9.144-6.27.54-12.185-2.51-18.24-3.536a90.92,90.92,0,0,0-14.541-1.355,23.205,23.205,0,0,0-6.848.709q-1.457.4-2.9.9c-3.7,1.277-6.895,1.517-9.62,4.618-1.4,1.59-3.174,8.6-2.722,10.738.905,4.264,6.664,3.495,10.221,3.339,10.418-.456,22.753.236,32.762-2.032a48.825,48.825,0,0,1,8.4-1.612c2.848-.128,5.68.264,8.529.184,5.513-.156,8.108-4.749,12.657-6.935,1.083-.521,3.211-1.535,3.211-1.535s4.048,3.857,4.682,1.868c.49-1.518-1.409-2.8-2.381-3.733a3.067,3.067,0,0,0-3.083-.984c-1.641.334-2.707.016-4.348.352a29.1,29.1,0,0,1,5.024-1.172,2.227,2.227,0,0,1,1.685.431,24.044,24.044,0,0,1,2.97,2.5,2.534,2.534,0,0,0,.756.7.892.892,0,0,0,1.284-.691,2.02,2.02,0,0,0-.322-1.491",
    transform: "translate(-175.574 -121.029)",
    fill: "#d0846a"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M514.689,275.085a115.818,115.818,0,0,1-4.365,13.293c-.027.083-.081.165-.108.247a94.236,94.236,0,0,1-5.685,11.756,1.235,1.235,0,0,1-1.105.549c-17.273-.137-38.042-9.719-62.268-23.2-.027-.027-.268-.515-.268-.515.153-.352-2.2.582-3.357-1.082.393-.422,4.1-1.831,4.078-2.224-.186-3.677-8.768-4.6-4.149-5.172,1.695-.21,7.551-.764,8.052-.023,13.474,4.038,25.252,7.968,32.878,8.957,1.186.137,2.345.3,3.53.467,3.207.44,6.44.934,9.674,1.484a.927.927,0,0,0,1.078-.769l1.509-9.943Z",
    transform: "translate(-221.522 -133.764)",
    fill: "#d0846a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2758",
    "data-name": "Group 2758",
    transform: "translate(258.612 118.934)",
    opacity: 0.22,
    style: {
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2757",
    "data-name": "Group 2757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2756",
    "data-name": "Group 2756",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M526.675,237.356a.561.561,0,0,1-.032.187h-1.014a.545.545,0,0,1-.033-.187.555.555,0,0,1,.038-.2h1a.546.546,0,0,1,.038.2",
    transform: "translate(-525.596 -237.155)",
    fill: "#333"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2761",
    "data-name": "Group 2761",
    transform: "translate(258.65 118.585)",
    opacity: 0.22,
    style: {
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2760",
    "data-name": "Group 2760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2759",
    "data-name": "Group 2759",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M526.676,236.808h-1a.536.536,0,0,1,1,0Z",
    transform: "translate(-525.672 -236.459)",
    fill: "#333"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764",
    transform: "translate(258.645 119.323)",
    opacity: 0.22,
    style: {
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2763",
    "data-name": "Group 2763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M525.662,237.93h1.013c-.006.017-.012.032-.019.048a.534.534,0,0,1-.948.05.58.58,0,0,1-.046-.1Z",
    transform: "translate(-525.662 -237.93)",
    fill: "#333"
  }))))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M525.589,239.094a8.668,8.668,0,0,1-.053,2.706.589.589,0,0,0,.053.533c.092.1.267.034.9,0,.109-.006.2-.01.253-.011-.16.005-.217-.72-.22-.81q-.017-.52-.041-1.036a13.756,13.756,0,0,1,.008-1.392.892.892,0,0,1-.239.1.951.951,0,0,1-.222.027.907.907,0,0,1-.443-.114",
    transform: "translate(-266.933 -119.182)",
    fill: "#0d61d2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M529.811,236.847a.707.707,0,0,1-.1.564.511.511,0,0,1-.352.154.861.861,0,0,1-.7-.316,1.383,1.383,0,0,1-.226-.75,2.433,2.433,0,0,0-.457-1.144c-.353-.457-.938-.455-1.434-.628a1.085,1.085,0,0,1-.18-.068c0-.123.007-.248.007-.377,0-.168,0-.331-.008-.488a1.933,1.933,0,0,0,.876.431,2.1,2.1,0,0,0,.369.034,2.058,2.058,0,0,0,1.859-1.2,2.148,2.148,0,0,0,.19-.7c.006-.066.01-.132.01-.2a2.121,2.121,0,0,0-.189-.878h0a2.1,2.1,0,0,0-.609-.781q-.26-.205,0,0a2.028,2.028,0,0,0-1.115-.435c-.048,0-.1-.006-.145-.006a2.068,2.068,0,0,0-1.947,1.411h.956l-1.177,1.239-1.179-1.239h.837a2.626,2.626,0,0,1,4.243-1.433c.03.025.059.052.088.078h0a2.757,2.757,0,0,1,.593.792h0a2.965,2.965,0,0,1,.295,1,2.537,2.537,0,0,1-.624,2.016,2.26,2.26,0,0,1-.322.289,1.326,1.326,0,0,0-.434.47.67.67,0,0,0-.045.448,2.094,2.094,0,0,0,.271.643c.12.187.3.327.426.507a1.257,1.257,0,0,1,.186.382,1.355,1.355,0,0,1,.039.186",
    transform: "translate(-266.303 -114.365)",
    fill: "#ed6c4d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17949",
    "data-name": "Rectangle 17949",
    width: 0.932,
    transform: "translate(258.684 118.948)",
    fill: "#fff"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M526.208,236.536a.5.5,0,0,0-.466.324h.932a.5.5,0,0,0-.466-.324",
    transform: "translate(-267.058 -117.912)",
    fill: "#f8984b"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M525.67,237.37a.507.507,0,0,0,.03.173h.941a.526.526,0,0,0,.031-.173.511.511,0,0,0-.035-.187h-.932a.511.511,0,0,0-.035.187",
    transform: "translate(-267.021 -118.235)",
    fill: "#fff"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M525.775,237.993a.5.5,0,0,0,.88-.046c.006-.014.012-.03.018-.045h-.941a.493.493,0,0,0,.043.091",
    transform: "translate(-267.053 -118.593)",
    fill: "#218b15"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17950",
    "data-name": "Rectangle 17950",
    width: 0.941,
    transform: "translate(258.679 119.309)",
    fill: "#218b15"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup29141);
export default __webpack_public_path__ + "static/media/Group 2914 (1).e8aa469199e10484742e5088ee892d40.svg";
export { ForwardRef as ReactComponent };